import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { TranslocoPipe } from '@jsverse/transloco';
import { RmaIconComponent, RmaIcons } from '@rma/generic/ui/icon';
import { MarketReportStatistic, MarketReportStatisticType } from '../domain';

@Component({
  selector: 'rma-market-report-statistics',
  templateUrl: './market-report-statistics.component.html',
  styleUrls: ['./market-report-statistics.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCardModule, RmaIconComponent, TranslocoPipe],
})
export class MarketReportStatisticsComponent {
  @Input() name: string;
  @Input() statistics: MarketReportStatistic[];

  public readonly icons: Record<MarketReportStatisticType, RmaIcons> = {
    [MarketReportStatisticType.activeListings]: 'rma-for-sale',
    [MarketReportStatisticType.soldListings]: 'rma-sale',
    [MarketReportStatisticType.leasedListings]: 'rma-sale',
    [MarketReportStatisticType.averageSalePrice]: 'local_atm',
    [MarketReportStatisticType.totalSalePrice]: 'trending_up',
    [MarketReportStatisticType.totalRecommendations]: 'thumb_up',
    [MarketReportStatisticType.averageStarRating]: 'star',
  };
}
